import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/pdf';
const API_STATIC_URL = process.env.VUE_APP_ROOT_DISPLAY_STATIC + '/pdf'
const serviceName = "Pdf-Service: ";

const sortTableFields = ["createAt"];
const sortDatabaseFields = ["createAt"];

export default class PdfService {

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/page', {params : params}, serviceName, successF, errorF);
  }

  static async downloadPdf(id, onSuccess, onError) {
    let url = API_STATIC_URL + '/' + id + '.pdf';
    await WrapperService.get(url, {responseType: 'blob'}, serviceName,
      response => {
        onSuccess(response.data)
      },
      error => {
        if (onError) {
          onError(error);
        }
      }
    )
  }

  static async sendPdfCheckStatusRequest(id, successF, errorF) {
    await WrapperService.get(API_URL + '/' + id + '/finished', null, serviceName, successF, errorF);
  }

}